import DateSelector from 'components/inputs/dateSelector';
import Page from 'components/menu/page.component';
import { useTranslation } from 'react-i18next';
import PlanningComponent from '../components/planning.component';
import { ErrorIcons } from 'components/other/_ErrorIcons';
import usePlanningView from '../hook/planningView.hook';
import { useEffect, useState } from 'react';
import { ViewOptionsMenu } from 'components/menu/viewOptionsMenu.component';
import { Warning } from 'interfaces/warning.interface';
import WarningComponent from 'features/warning/components/warning.component';
import TimeGridSelectorComponent from 'features/timegrid_selector/components/timegrid_selector.component';
import { TimeGrid } from 'interfaces/timegrid.interface';
import { DEFAULT_VALUES } from 'constants/calendar.constants';


function PlanningView() {
  const { t } = useTranslation();

  const {
    currentDay, setCurrentDay,
    planning,
    tasks,
    settings,
    isDayView,
    equipments,
    equipmentsTasks,
    onSectorsChange,
    onTaskCreate,
    onTaskUpdate,
    onTaskDelete,
    onViewChange,
    refreshTasks,
    taskActionImages,
    selectedSectorId,
    update
  } = usePlanningView();

  const [ isAdmin, setIsAdmin ] = useState( false );
  const [ showOnlyMyTasks, setShowOnlyMyTasks ] = useState<boolean>( false );
  const [ highlightMyTasks, setHighlightMyTasks ] = useState<boolean>( false );

  const [ , setWarnings ] = useState<Warning[]>( [] );
  const [ openTaskModal, setOpenTaskModal ] = useState<string | undefined>();
  const [ selectedTimeGrid, setSelectedTimeGrid ] = useState<TimeGrid>( {
    id: 'virtual_time_grid',
    name: '',
    idSector: selectedSectorId,
    timeStart: `1970-1-0 ${ settings?.calendarStartHour?.value ?? DEFAULT_VALUES.HOURSTART }:00`,
    timeEnd: `1970-1-0 ${ settings?.calendarEndHour?.value ?? DEFAULT_VALUES.HOUREND }:00`,
    disabled: false,
    breaktimes: [],
  } as TimeGrid );

  useEffect( () => {
    if ( openTaskModal != null ) {
      setOpenTaskModal( undefined );
    }
  }, [ openTaskModal ] );

  return (
    <Page
      footer={true}
      isAdminRequired={ false }
      onSectorChange={ onSectorsChange }
      setIsAdmin={ setIsAdmin }
      headerNavigateBarChildren={
        <div className='col-flex xl:grid grid-flow-col grid-cols-2 self-justify-end w-full'>
          <div className='flex items-center justify-center gap-x-2 w-full'>
            <div className='w-fit'>
              <DateSelector
                setCurrentDay={ setCurrentDay }
                currentDay={ currentDay }
                isWeek={ !isDayView }
                areWeekEnd={ ( settings?.showWeekend?.value ?? 0 ) == 1 }
              />
            </div>
            <div className="w-fit mt-1">
              <ViewOptionsMenu
                isDayView={isDayView}
                highlightMyTasks={highlightMyTasks}
                showOnlyMyTasks={showOnlyMyTasks}
                onViewChange={onViewChange}
                onHighlightMyTasks={setHighlightMyTasks}
                onShowOnlyMyTasks={setShowOnlyMyTasks}
              />
            </div>
          </div>

          <div className='flex items-center justify-center gap-x-2 w-full'>
            { planning &&
              <WarningComponent
                planningId={planning.id}
                onOpenWarning={ setOpenTaskModal }
                className='z-20'
                update={ update }
              />
            }

            { selectedSectorId &&
              <TimeGridSelectorComponent
                sectorId={ selectedSectorId }
                onTimeGridChange={ setSelectedTimeGrid }
                className='z-20'
                canBeEmpty
              />
            }
          </div>
        </div>
      }
    >
      <>
        <div className="p-0 mt-1 -mr-4 h-full pb-3 ">
          { planning ?
            <PlanningComponent
              planning={planning}
              tasks={tasks}
              currentDate={currentDay}
              settings={settings}

              onTaskCreate={isAdmin ? onTaskCreate : undefined}
              onUpdate={isAdmin ? onTaskUpdate : undefined}
              onDeleteTask={isAdmin ? onTaskDelete : undefined}

              isDayView={ isDayView }
              refreshTask={ async () => { await refreshTasks( planning?.id ); }}
              showOnlyMyTasks={showOnlyMyTasks}
              highlightMyTasks={highlightMyTasks}
              equipments={ equipments }
              equipmentsTasks={ equipmentsTasks }
              taskActionImages={taskActionImages}
              fixed={!isAdmin}
              onWarnings={ setWarnings }

              openTaskModal={ openTaskModal }
              timegrid={ selectedTimeGrid }
            />
            :
            <div className="flex flex-col items-center justify-center h-64 text-gray-500">
              <span className="w-16 h-16 mb-4 flex items-center justify-center">{ <ErrorIcons error={undefined} size={8}/> }</span>
              <h3 className="text-lg font-medium mb-2">{ t( 'translation:no_calendar' ) }</h3>
            </div>
          }
        </div>
      </>
    </Page>
  );
}

export default PlanningView;